import { flatMap } from "lodash";
import Field from "models/field";
import Value from "models/field"
import { ReactNode } from "react";
import FormContainer from "Components/atoms/containers/form-container";

interface GenerateDocumentsFormProps {
    fields: Field[];
    renderInput: (_field: Field) => ReactNode
}

const GenerateDocumentForm = ({ fields, renderInput }: GenerateDocumentsFormProps) => {

    return <FormContainer inputs={<>
        {Array.from(fields).map((f: Value) => renderInput(f))}
    </>} />
}


export default GenerateDocumentForm
